import { createLucideIcon } from "lucide-react";

export const Money = createLucideIcon(
    "Money",
    [
        [
            "path",
            {
                d: "M12.6663 7.4278C12.4496 7.3964 12.227 7.3724 11.9997 7.3565",
                key: "8t6w3m",
            },
        ],
        [
            "path",
            {
                d: "M3.9997 8.6436C3.7723 8.6277 3.5498 8.6038 3.333 8.5724",
                key: "vsuswy",
            },
        ],
        [
            "path",
            {
                d: "M7.99967 13C7.11131 13.415 5.94439 13.6667 4.66634 13.6667C3.95573 13.6667 3.27947 13.5889 2.66634 13.4484C1.66606 13.2193 1.33301 12.6176 1.33301 11.5907V4.40935C1.33301 3.7528 2.02636 3.30186 2.66634 3.44844C3.27947 3.58888 3.95573 3.66671 4.66634 3.66671C5.94439 3.66671 7.11131 3.41495 7.99967 3.00004C8.88803 2.58513 10.055 2.33337 11.333 2.33337C12.0436 2.33337 12.7199 2.41121 13.333 2.55164C14.3875 2.79316 14.6663 3.41361 14.6663 4.40935V11.5907C14.6663 12.2473 13.973 12.6982 13.333 12.5516C12.7199 12.4112 12.0436 12.3334 11.333 12.3334C10.055 12.3334 8.88803 12.5851 7.99967 13Z",
                key: "w98edz",
            },
        ],
        [
            "path",
            {
                d: "M9.66634 8.0001C9.66634 8.92058 8.92015 9.66677 7.99967 9.66677C7.0792 9.66677 6.33301 8.92058 6.33301 8.0001C6.33301 7.07963 7.0792 6.33344 7.99967 6.33344C8.92015 6.33344 9.66634 7.07963 9.66634 8.0001Z",
                key: "f4o1y2",
            },
        ],
    ],
);
